import React from 'react'
import Dashboard from '../component/dashboard'
import StartLearning from '../component/startLearning';

import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import GuestLayout from '../component/layout/GuestLayout';
import Enquiry from '../component/enquiry';
import AboutGirlsLeadGirls from '../component/about-girls-lead-girls';
import HowItWorks from '../component/how-it-works';

import { connect } from 'react-redux';
import EmailVerification from '../component/email-verification';
import { useEffect } from 'react';
import { notification } from 'antd';
import { action } from '../store';
import { resetAllStatus, getUserInfo } from '../actions/Authentication-action';

const GuestContainer = ({ guest, profile }) => {
  const {
    message,
    isErrorAvailable,
    isEmailVerified,
    isUserRegistered,
    isPasswordUpdated,
    isUserTokenValid,
  } = guest;
  notification.config({
    duration: 20
  })
  useEffect(() => {
    if (isErrorAvailable) {
      notification["error"]({
        message
      });
      action(resetAllStatus());
    }
  }, [isErrorAvailable]);

  useEffect(() => {
    action(getUserInfo());
  }, []);

  return (
    <Router basename="/">
      <GuestLayout profile={profile}>
        <Switch>
          <Route exact path="/about-girls-lead-girls">
            <AboutGirlsLeadGirls />
          </Route>
          <Route exact path="/how-it-works">
            <HowItWorks />
          </Route>
          <Route exact path="/start-learning/login">
            <StartLearning guest={guest} keyNumber="1" isEmailVerified={isEmailVerified} />
          </Route>
          <Route exact path="/start-learning/register" render={() => {
            return isUserRegistered ? <Redirect to="/start-learning/login" /> : <StartLearning guest={guest} keyNumber="2" />
          }} />
          <Route exact path="/start-learning/forgot-password" render={() => {
            return isUserTokenValid ? <Redirect to="/start-learning/login" /> : <StartLearning guest={guest} keyNumber="3" />
          }} />

          <Route exact path="/change-password/:randomKey/:email" render={() => {
            return isPasswordUpdated ? <Redirect to="/start-learning/login" /> : <StartLearning guest={guest} keyNumber="4" />
          }} />

          <Route exact path="/email-verification/:token/:email" render={() => {
            return isEmailVerified ? <Redirect to="/start-learning/login" /> : <EmailVerification isEmailVerified={guest.isEmailVerified} loading={guest.loading} />
          }} />
          <Route exact path="/enquiry">
            <Enquiry />
          </Route>
          <Route path="/">
            <Dashboard />
          </Route>
        </Switch>
      </GuestLayout>
    </Router>
  )
}

const mapStateToProps = (state) => {
  const { GuestReducer, UserReducer: { profile } } = state;
  return { guest: GuestReducer, profile }
}

export default connect(mapStateToProps)(GuestContainer)